<template>
  <AccountPanel title="Faktury">
    <div v-if="badInvoice" class="alert alert-danger" role="alert">Brak faktury!</div>
    <div class="row">
      <div class="invoices-total col-10">
        <h4>Suma niespłaconych faktur:</h4>
        <span class="text-secondary">{{calculateUnpaid()}}</span>
      </div>
      <div class="col-2">
        <b-pagination
          align="right"
          :total-rows="company.invoicesCount"
          v-model="current"
          :per-page="limit"
        ></b-pagination>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">nr fakrury</th>
          <th scope="col">data wystawienia</th>
          <th scope="col">netto</th>
          <th scope="col">brutto</th>
          <th scope="col">termin płatności</th>
          <th scope="col">status</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="o in company.invoices">
          <td>{{o.number}}</td>
          <td>{{o.added}}</td>
          <td>{{formatPrice(o.netto)}}</td>
          <td>{{formatPrice(o.price)}}</td>
          <td>{{o.payment}}</td>
          <td>
            <div v-if="checkStatus(o.cost, o.payment) === 'zapłacona'">
              <b-button
                class="p-2 w-100 text-center m-0"
                style="pointer-events: none;"
                show
                variant="outline-success"
              >{{checkStatus(o.cost, o.payment)}}</b-button>
            </div>
            <div v-else-if="checkStatus(o.cost, o.payment) === 'niezapłacona'">
              <b-button
                :id="o.number"
                class="p-2 w-100 text-center m-0"
                variant="outline-danger"
                show
              >{{checkStatus(o.cost, o.payment)}}</b-button>
              <b-tooltip :target="o.number" variant="dark" placement="left">
                do zapłaty:
                <span style="font-weight: bold;">{{formatPrice(o.cost)}}</span> zł
              </b-tooltip>
            </div>
            <div v-else-if="checkStatus(o.cost, o.payment) === 'w terminie'">
              <b-button
                :id="o.number"
                class="p-2 w-100 text-center m-0"
                show
                variant="outline-warning"
              >{{checkStatus(o.cost, o.payment)}}</b-button>
              <b-tooltip :target="o.number" variant="dark" placement="left">
                do zapłaty:
                <span style="font-weight: bold;">{{formatPrice(o.cost)}}</span> zł
              </b-tooltip>
            </div>
          </td>


          <td>
            <b-button
              class="p-2 w-40 text-center m-0"
              variant="outline-success"
              @click="redirectPdf(o)"
            >
              <FileDocumentIcon title="wyświetl fakturę" />
            </b-button>
            <b-button
              class="p-2 w-40 text-center m-0 ml-2"
              variant="outline-info"
              @click="redirectFak(o)"
            >
              <FileIcon title="Pobierz plik FAK" />
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      align="right"
      :total-rows="company.invoicesCount"
      v-model="current"
      :per-page="limit"
    ></b-pagination>
  </AccountPanel>
</template>


<script>
  import { mapState } from "vuex";
  import AccountPanel from "./AccountPanel.vue";
  import { BFormSelect } from "bootstrap-vue/esm/components/form-select/form-select";
  import { BPagination } from "bootstrap-vue/esm/components/pagination/pagination";
  import { BProgress } from "bootstrap-vue/esm/components/progress/progress";
  import { Alert } from "bootstrap-vue/esm/components/alert/alert";
  import { Tooltip } from "bootstrap-vue/esm/components/tooltip/tooltip";
  import FileDocumentIcon from "vue-material-design-icons/FileDocument.vue";
  import FileIcon from "vue-material-design-icons/FileExportOutline.vue";
  import ApiClient from "../../../../components/api/src/ApiClient";
  import md5 from "md5";

export default {
  components: {
    AccountPanel,
    BPagination,
    BProgress,
    BFormSelect,
    FileDocumentIcon,
    FileIcon,
    md5
  },
  data() {
    return {
      limit: 20,
      offset: 0,
      current: 1,
      order: "added desc",
      orderOptions: [
        { value: "added desc", text: "Najnowszej" },
        { value: "added asc", text: "Najstarszej" },
        { value: "payment desc", text: "Termin płatności malejąco" },
        { value: "payment asc", text: "Termin płatności rosnąco" },
        { value: "price desc", text: "Najwyższej kwoty" },
        { value: "price asc", text: "Najniższej kwoty" }
      ],
      status: 0,
      statusOptions: [
        { value: 0, text: "wszytkie" },
        { value: 1, text: "zapłacone / rozliczone" },
        { value: 2, text: "do zapłaty / do rozliczenia" }
      ],
      badInvoice: false
    };
  },
  computed: {
    ...mapState({
      company: state => state.company,
      shopSettings: state => state.shop.settings
    })
  },
  watch: {
    current: function(value) {
      this.offset = (value - 1) * this.limit;
    },
    offset: function(value) {
      this.$store.dispatch("company/invoiceList", {
        limit: this.limit,
        offset: value
      });
    }
  },

  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    checkStatus(cost, date) {
      let now = new Date();
      now.setHours(0,0,0,0);
      let payment = new Date(date);
      if (cost <= 0) {
        return "zapłacona";
      }
      if (now.getTime() > payment.getTime()) {
        return "niezapłacona";
      }
      return "w terminie";
    },
    getShopSetting(name) {
      let setting = this.shopSettings.find(s => s.name == name);
      return setting ? setting.value : "";
    },

    redirectPdf(item) {
      let dataHash = this.formatPrice(item.price).replace('.','').replace(',', '.') + "00-" + item.number + "-RAIHBUDA";
      let domain = this.getShopSetting("B2B_INVOICE_DOMAIN");
      let type = this.getShopSetting("B2B_INVOICE_TYPE");
      let url =
        domain +
        "/pl/shop/orders/getinvoice?name=" +
        item.number +
        "&type=" +
        type +
        "&sig=" +
        md5(dataHash);
      window.open(url, "_blank");
    },

    redirectFak(item) {
      let dataHash = this.formatPrice(item.price).replace('.','').replace(',', '.') + "00-" + item.number + "-RAIHBUDA";
      let domain = this.getShopSetting("B2B_INVOICE_DOMAIN");
      let type = 'polsoftfak';
      let url =
        domain +
        "/pl/shop/orders/getinvoice?name=" +
        item.number +
        "&type=" +
        type +
        "&sig=" +
        md5(dataHash);
      window.open(url, "_blank");
    },

    calculateUnpaid() {
      let setting = this.company.settings.find(s => s.property == "IPH_DEPT");
      let total = setting != null ? setting.value : 0;
      return `${total} ${
        this.company.currencies[this.company.selectedCurrencyKey].currency
          .symbol
      }`;
    }
  },

  beforeMount() {
    this.$store.dispatch("company/settings");
    this.$store.dispatch("company/invoiceList", {
      limit: this.limit,
      offset: this.offset
    });
    this.$store.dispatch("company/invoicesCount", { type: this.status });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/InvoicePage.vue